import script from "./MySkills.vue?vue&type=script&setup=true&lang=js"
export * from "./MySkills.vue?vue&type=script&setup=true&lang=js"

import "./MySkills.vue?vue&type=style&index=0&id=62962712&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62962712"]])

export default __exports__